import { SectionHeading } from './SectionHeading'

const awards = [
  {
    date: '2023',
    title: '九州工業大学 学生表彰 特別賞（令和5年度）',
    detail:
      '自ら立ち上げた学生プロジェクト「Comet」の活動が評価され、大学より特別賞を受賞。',
    href: 'https://www.kyutech.ac.jp/archives/025/202306/2022gakuseihyousyo.pdf'
  },
  {
    date: '2022.11',
    title: 'e-ZUKAスマートアプリコンテスト2022 — 企業賞',
    detail: 'ハウインターナショナル賞を受賞。',
    href: ''
  },
  {
    date: '2022.06',
    title: 'ハックツハッカソン〜イクチオカップ〜 — 優秀賞',
    detail: '株式会社ハックツ主催のハッカソンにて優秀賞を受賞。',
    href: ''
  },
  {
    date: '2022',
    title: '九州工業大学 学生表彰 技術賞（令和4年度）',
    detail:
      '在学中の個人での開発・コンテストでの成果に対して、大学より技術賞を受賞。',
    href: 'https://www.kyutech.ac.jp/archives/025/202206/2021gakuseihyousyo.pdf'
  },
  {
    date: '2021',
    title: 'Digital Hack Day 2021 — 特別賞',
    detail:
      'Yahoo! JAPAN主催。防災アプリ「MAPCHAIN」で LINE Blockchain Developers賞・Mapbox賞 を受賞。',
    href: 'https://www.kyutech.ac.jp/whats-new/topics/entry-8633.html'
  },
  {
    date: '2021',
    title: 'SAI ZEN SEN for tech 2021 SUMMER — 登壇',
    detail:
      '長崎・CO-DEJIMAにて、自治体の申請書類作成を支援するLINE Botなどを発表。',
    href: 'https://www.kyutech.ac.jp/whats-new/topics/entry-8450.html'
  }
]

export const Awards = () => {
  return (
    <section id="awards" className="py-12 border-t border-ink-100">
      <SectionHeading number="03" title="受賞・登壇" />
      <ol className="space-y-6">
        {awards.map(({ date, title, detail, href }) => {
          const heading = href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-ink-400/30"
            >
              {title}
              <span className="sr-only">（外部サイト、新しいタブで開く）</span>
            </a>
          ) : (
            title
          )

          return (
            <li
              key={title}
              className="grid gap-1 sm:grid-cols-[8rem_1fr] sm:gap-6"
            >
              <div className="font-mono text-xs tabular-nums tracking-wider text-ink-600 pt-[3px]">
                {date}
              </div>
              <div>
                <h3 className="text-base font-semibold leading-relaxed text-ink-800">
                  {heading}
                </h3>
                <p className="mt-1 text-base leading-[1.9] text-ink-700">
                  {detail}
                </p>
              </div>
            </li>
          )
        })}
      </ol>
    </section>
  )
}
